'use strict'

// Single integration / registrar logo tile.
//
// Resolves a brand glyph from the marketplace design system (scratch's icon
// sprite) by slug via the Icon component — local-only, no CDN. When no local
// logo ships for the slug (newer integration_kinds rows, or brands simple-icons
// dropped for trademark reasons), it renders a kind-accented letter chip
// instead of a broken image.
//
// Replaces the former per-surface `<img src="cdn.simpleicons.org/…">` + onerror
// + `_imgFailed` pattern that was copy-pasted across six components. Parents pass
// flat `logo` (slug), `name` (letter source), and `kind` (accent), and may
// override the box sizing (width/height/minWidth/borderRadius/fontSize).
export const IntegrationLogo = {
  align: 'center center',
  overflow: 'hidden',
  fontWeight: '700',
  width: 'B',
  height: 'B',
  minWidth: 'B',
  borderRadius: 'radiusControl',
  fontSize: 'A',
  background: (el) => el.call('getKindAccent', el.kind, 'bg'),
  color: (el) => el.call('getKindAccent', el.kind, 'fg'),

  // Brand glyph — shown only when a local logo exists for the slug. Inherits
  // `color` (the kind accent fg) via the Icon's `fill: currentColor`.
  Icon: {
    if: (el) => !!(el.parent.logo && el.call('hasIntegrationLogo', el.parent.logo)),
    name: (el) => el.parent.logo,
    width: '60%',
    height: '60%'
  },

  // Letter fallback — first character of the name, shown when there's no
  // local logo for the slug (or no slug at all).
  LogoLetter: {
    hide: (el) => !!(el.parent.logo && el.call('hasIntegrationLogo', el.parent.logo)),
    tag: 'span',
    // The initial comes from the RESOLVED name — a row whose name is a bundle
    // key would otherwise render "a" from `apps.catalog.…`.
    text: (el) => (el.call('storeItemText', el.parent, 'name') || '')[0]?.toUpperCase() || '?'
  }
}
